import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ListingContext from '../../../../providers/Listing/Listing.context';
import AddNdaButton from 'components/AddNdaButton';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import UploadNda from './components/UploadNda';
import NdaUploaded from './components/NdaUploaded';

import './AddCustomNdaCard.styles.scss';

type AddCustomNdaCardProps = {
  className?: string;
};

const AddCustomNdaCard: React.FC<AddCustomNdaCardProps> = (props) => {
  const { className } = props;

  const { isSuperAdmin } = useContext(CurrentUserContext);
  const { areActionsDisabled, listing, dealRoom, setListing } =
    useContext(ListingContext);

  const { _id: listingId, envelopeTemplateId } = listing || {};

  const { listingNDA } = dealRoom || {};

  const classes = classNames('add-custom-nda-card', className);

  const { t } = useTranslation();

  // NDA is uploaded by broker, but Resolve team has not link file with Docusign
  const showNdaInPreparation = useMemo(
    () => !isSuperAdmin && !envelopeTemplateId && listingNDA,
    [envelopeTemplateId, isSuperAdmin, listingNDA],
  );

  const title = useMemo(() => {
    if (showNdaInPreparation) return t('ndaInPreparation');

    return t('nonDisclosureAgreement');
  }, [showNdaInPreparation, t]);

  const subtitle = useMemo(() => {
    if (showNdaInPreparation) return t('ndaInPreparationDescritpion');

    if (!listingNDA && !envelopeTemplateId) {
      return t('youDontHaveNda');
    }

    return '';
  }, [showNdaInPreparation, listingNDA, envelopeTemplateId, t]);

  return (
    <div className={classes}>
      <p className="title">{title}</p>

      {subtitle && <p className="subtitle">{subtitle}</p>}

      {envelopeTemplateId ? (
        <NdaUploaded />
      ) : (
        <>
          {/* for BM to choose which NDA to link */}
          <AddNdaButton
            listingId={listingId}
            envelopeTemplateId={envelopeTemplateId}
            isDisabled={areActionsDisabled}
            setListing={setListing}
          />

          {/* for broker to upload NDA to DR */}
          <UploadNda />
        </>
      )}
    </div>
  );
};

export default AddCustomNdaCard;
